"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUi = void 0;
const app_1 = require("@obvio/app");
const reducer = {
    TOGGLE_CART: ({ cartOpen }) => ({
        cartOpen: !cartOpen,
        searchPanelOpen: false,
        menuPanelOpen: false,
    }),
    CLOSE_CART: () => ({ cartOpen: false }),
    OPEN_CART: () => ({
        cartOpen: true,
        searchPanelOpen: false,
        menuPanelOpen: false,
    }),
    TOGGLE_SEARCH_PANEL: ({ searchPanelOpen }) => ({
        searchPanelOpen: !searchPanelOpen,
        cartOpen: false,
        menuPanelOpen: false,
    }),
    OPEN_SEARCH_PANEL: () => ({
        searchPanelOpen: true,
        cartOpen: false,
        menuPanelOpen: false,
    }),
    TOGGLE_MENU_PANEL: ({ menuPanelOpen }) => ({
        menuPanelOpen: !menuPanelOpen,
        searchPanelOpen: false,
        cartOpen: false,
    }),
    CLOSE_SEARCH_PANEL: () => ({ searchPanelOpen: false }),
    OPEN_MENU_PANEL: () => ({
        menuPanelOpen: true,
        searchPanelOpen: false,
        cartOpen: false,
    }),
    CLOSE_MENU_PANEL: () => ({ menuPanelOpen: false }),
    CLOSE_ALL_PANELS: () => ({
        cartOpen: false,
        menuPanelOpen: false,
        searchPanelOpen: false,
    }),
    CLOSE_ECOM_MENU_PANEL: () => ({ ecomMenuPanelOpen: false }),
    OPEN_ECOM_MENU_PANEL: () => ({ ecomMenuPanelOpen: true }),
    TOGGLE_ECOM_MENU_PANEL: ({ ecomMenuPanelOpen }) => ({
        ecomMenuPanelOpen: !ecomMenuPanelOpen,
    }),
};
exports.useUi = (0, app_1.createStore)(reducer, {
    cartOpen: false,
    searchPanelOpen: false,
    menuPanelOpen: false,
    ecomMenuPanelOpen: false,
});
